import { SelectionCaption } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummaryNew.style';
import { SelectionCast } from 'src/domains/sportsbook/webview/components/selectionCast/SelectionCast';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const ExtraPlacesRaceSummaryCaption = withConfig(theme => styled('li', { label: 'ExtraPlacesRaceSummaryCaption' })`
    background: ${theme.star.raceSummary.bgColorSecondary};
    border-color: ${theme.star.selection.borderColor};
    border-style: solid;
    border-width: 1px 0 1px 0;
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    height: 30px;
    justify-content: space-between;
    line-height: 1.4;
    width: 100%;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 1px 0 1px 1px;
    }
`);

export const ExtraPlacesRunnerCaption = withConfig(theme => styled('li', { label: 'ExtraPlacesRunnerCaption' })`
    align-items: center;
    display: flex;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: flex-start;
    padding-left: 16px;
`);

export const ExtraPlacesSelectionCaption = styled(SelectionCaption, { label: 'ExtraPlacesSelectionCaption' })`
    flex: 0 0 64px;
`;

export const ExtraPlacesSelectionCast = withConfig(theme => styled(SelectionCast, { label: 'ExtraPlacesSelectionCast' })`
    border-width: 0 0 1px 1px;
    border-style: solid;
    border-color: ${theme.star.raceSummary.borderColor};
    flex: 0 0 64px;
    margin-left: 0;
    @media ${theme.star.mediaQuery.tablet} {
        margin-left: -1px;
    }
`);
